<template>
  <v-select
    outlined
    dense
    @input="event => { emitChange(event) }"
    v-model="selectedItem"
    :items="items"
    :value="items[0]"
    item-text="text"
    item-value="value"
    :label="$t('message.select_interval')"
  ></v-select>
</template>

<script>
export default {
  data () {
    return {
      selectedItem: 1,
      items: this.getIntervalOptions()
    }
  },
  props:['value'],
  created(){
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newValue) {
        this.selectedItem = newValue
      }
    }
  },
  methods: {
    emitChange (event) {
      this.$emit('input', event)
    }
  }
}
</script>

<style scoped>
</style>
